<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-popup
      v-if="!isMobile()"
      :title="
        Object.entries(this.data).length === 0 ? $t('AddNewStock') : $t('UPDATEStock')
      "
      button-cancel="border"
      :active.sync="isSidebarActiveLocal"
      classContent="popup-example"
      fullscreen
    >
      <vs-popup
        class="holamundo"
        :title="$t('StocktransDetail') + ' (' + infoData.Stockno + ') '"
        :active.sync="isSstocktransDetailPopup"
        fullscreen
      >
        <StockTransDetails :data="infoData" :type="'stock'" />
      </vs-popup>
      <StorehouseAddNew
        :isSidebarActiveStorehouse="addNewDataSidebarinStock"
        @closeSidebar="toggleDataSidebar"
        :company="customer"
        :data="storehouseData"
      />

      <b-row>
        <b-col>
          <vs-card>
            <b-tabs content-class="mt-3" v-model="tabIndexS1">
              <b-tab :title="$t('General')" active>
                <component
                  :is="scrollbarTag"
                  ref="scroll"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row v-if="ROLE != 'Company'">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('Customer')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <v-select
                          color="danger"
                          v-model="customer"
                          :options="customer_choices"
                          size="small"
                          label="name"
                          v-if="stockId || companyinfo"
                          disabled
                          v-on:input="getCustomerDepoList"
                          autocomplete
                          ref="selectElement"
                          name="customer"
                          v-validate="'required'"
                        >
                        </v-select>
                        <v-select
                          color="danger"
                          v-model="customer"
                          :options="customer_choices"
                          size="small"
                          label="name"
                          v-else
                          v-on:input="getCustomerDepoList"
                          autocomplete
                          ref="selectElement"
                          name="customer"
                          v-validate="'required'"
                        >
                        </v-select>
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('customer')"
                          >{{ errors.first("customer") }}</span
                        >
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px" align-v="center">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('Storehouse')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="7">
                        <v-select
                          color="danger"
                          v-model="storehouse"
                          :options="storehouse_choices"
                          size="small"
                          label="name"
                          v-if="stockId || companyinfo || barcodeValidate"
                          disabled
                          autocomplete
                          ref="selectElement"
                          name="storehouse"
                          v-validate="'required'"
                        >
                        </v-select>
                        <v-select
                          color="danger"
                          v-model="storehouse"
                          :options="storehouse_choices"
                          size="small"
                          label="name"
                          v-else
                          autocomplete
                          ref="selectElement"
                          name="storehouse"
                          v-validate="'required'"
                        >
                        </v-select>
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('storehouse')"
                          >{{ errors.first("storehouse") }}</span
                        >
                      </b-col>
                      <b-col
                        cols="1"
                        class="ml-0"
                        style="padding-left: 0px; margin-left: 0px !important"
                      >
                        <b-button
                          v-if="
                            customer != '' || stockId || companyinfo || barcodeValidate
                          "
                          variant="outline-light"
                          style="padding: 0px"
                          v-on:click="addStorehouse()"
                        >
                          <Icon
                            icon="ic:outline-settings"
                            width="20"
                            height="20"
                            v-b-tooltip.hover.bottom="$t('StorehouseManagement')"
                            color="#7367F0"
                          />
                        </b-button>
                        <b-button
                          v-else
                          disabled
                          variant="outline-light"
                          style="padding: 0px"
                          v-on:click="addStorehouse()"
                        >
                          <Icon
                            icon="ic:outline-settings"
                            width="20"
                            height="20"
                            v-b-tooltip.hover.bottom="$t('StorehouseManagement')"
                            color="#7367F0"
                          />
                        </b-button>
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('Stockno')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="stockno"
                          type="text"
                          class="w-full"
                          name="stockno"
                          v-validate="'required'"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('stockno')"
                          >{{ errors.first("stockno") }}</span
                        >
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CustomerStockNo')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="customerStockNo"
                          type="text"
                          name="customerStockNo"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('StockName')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="stockName"
                          type="text"
                          class="w-full"
                          v-validate="'required'"
                          name="stockName"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('stockName')"
                          >{{ errors.first("stockName") }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('Brand')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="brand"
                          type="text"
                          class="w-full"
                          v-validate="'required'"
                          name="brand"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('brand')">{{
                          errors.first("brand")
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row v-if="stockId || companyinfo"></b-row>
                    <b-row style="margin-top: 8px" v-else>
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="'* ' + $t('MainBarcode')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="mainBarcode"
                          type="text"
                          class="w-full"
                          v-validate="'required'"
                          name="mainBarcode"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('mainBarcode')"
                          >{{ errors.first("mainBarcode") }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('StockName2')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="stockName2"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('serialFollow')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <v-select
                          color="danger"
                          v-model="serialFollow"
                          :options="serialFollow_choices"
                          size="small"
                          label="text"
                          autocomplete
                          ref="selectElement"
                        >
                        </v-select>
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('Status')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <v-select
                          color="danger"
                          v-model="status"
                          :options="status_choices"
                          size="small"
                          label="text"
                          autocomplete
                          ref="selectElement"
                        >
                        </v-select>
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CancelDate')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <b-form-datepicker
                          id="baslangic"
                          v-model="cancelDate"
                          size="md"
                          :locale="locale"
                          class="mb-2"
                          today-variant="danger"
                          placeholder="-"
                          :start-weekday="weekday"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                          }"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('Description')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-textarea v-model="description" />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('Note')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-textarea v-model="note" />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Special')">
                <component
                  :is="scrollbarTag"
                  ref="scroll1"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('GroupCode')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="groupCode"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '1'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode1"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '2'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode2"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '3'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode3"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '4'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode4"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '5'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode5"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '6'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode6"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '7'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode7"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '8'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode8"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '9'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode9"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('SpecCode') + '10'"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="specCode10"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
              <b-tab
                :title="$t('Barcodes')"
                :disabled="stockData.length == 0"
                @click="getStockBarcodes"
              >
                <component
                  :is="scrollbarTag"
                  ref="scroll1"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <BarcodeAddNew :data="stockData" ref="getStockBarcodes" />
                </component>
              </b-tab>

              <b-tab
                :title="$t('SerialNumbers')"
                :disabled="stockData.length == 0"
                @click="getStockSerialNumbers"
              >
                <component
                  :is="scrollbarTag"
                  ref="scroll1"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <SerialNumberAddNew :data="stockData" ref="getStockSerialNumbers" />
                </component>
              </b-tab>
            </b-tabs>
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <b-tabs content-class="mt-3" v-model="tabIndexS2">
              <b-tab :title="$t('Account')" active>
                <component
                  :is="scrollbarTag"
                  ref="scroll2"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('Debit')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="debit"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('Credit')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="credit"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('RemTotal')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="remTotal"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('RemType')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="remType"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Currency')">
                <component
                  :is="scrollbarTag"
                  ref="scroll3"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CurrCode')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="currCode"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CurrDebit')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="currDebit"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CurrCredit')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="currCredit"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CurrRemTotal')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="currRemTotal"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('CurrRemType')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="currRemType"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Quantity')">
                <component
                  :is="scrollbarTag"
                  ref="scroll4"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QEntery')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qEntery"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QExit')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qExit"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QRem')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qRem"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QRem2')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qRem2"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QRem3')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qRem3"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QReserve')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qReserve"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QReserve2')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qReserve2"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QReserve3')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qReserve3"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QDepot')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qDepot"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('UnitId')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="unitId"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QuantityMin')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="quantityMin"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QuantityMax')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="quantityMax"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('MinOrderQuantity')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="minOrderQuantity"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
            </b-tabs>
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <b-tabs content-class="mt-3" v-model="tabIndexS3">
              <b-tab :title="$t('Vat')">
                <component
                  :is="scrollbarTag"
                  ref="scroll5"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('VatSales')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="vatSales"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('VatPurChase')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="vatPurChase"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('TaxPrivate')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="taxPrivate"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('TaxPrivateTotal')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="taxPrivateTotal"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Other')">
                <component
                  :is="scrollbarTag"
                  ref="scroll6"
                  class="vs-input--label scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-2">
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('OrdersLevel')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="ordersLevel"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('ActSupplierId')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="actSupplierId"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('PackageQuantity')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="packageQuantity"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('msg')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input size="small" v-model="msg" type="text" class="w-full" />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('minReqQuantity')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="minReqQuantity"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('TransCode')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="transCode"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>

                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('Origin')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="origin"
                          type="text"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                    <b-row style="margin-top: 8px">
                      <b-col cols="4" align-self="center">
                        <b-form-group
                          :label="$t('QtyTree')"
                          label-for="h-first-name"
                          style="font-weight: 600"
                        >
                        </b-form-group>
                      </b-col>
                      <b-col cols="8">
                        <vs-input
                          size="small"
                          v-model="qtyTree"
                          type="number"
                          class="w-full"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </component>
              </b-tab>
            </b-tabs>
          </vs-card>
        </b-col>
      </b-row>

      <div class="items-center pl-6 mt-0 mb-0">
        <b-row>
          <b-col v-if="Object.entries(data).length !== 0">
            <b-row align-h="start">
              <b-col cols="3" md="auto" style="padding: 0px">
                <b-button
                  class="bg-dark"
                  style="border-color: white"
                  v-on:click="listStockTrans(data)"
                >
                  <Icon
                    icon="ant-design:product-filled"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("ListStockTrans") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto" style="padding: 0px">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="isSidebarActiveLocal = false"
                >
                  <Icon icon="material-symbols:cancel-outline" width="20" height="20" />{{
                    $t("Cancel")
                  }}
                </b-button>
              </b-col>
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="submitData()"
                >
                  <Icon icon="material-symbols:save-outline" width="20" height="20" />{{
                    $t("Save")
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </vs-popup>
    <vs-sidebar
      v-else
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <vs-popup
        style="z-index: 1111111111111"
        class="holamundo"
        :title="$t('StocktransDetail') + ' (' + infoData.Stockno + ') '"
        :active.sync="isSstocktransDetailPopup"
        fullscreen
      >
        <StockTransDetails :data="infoData" :type="'stock'" />
      </vs-popup>
      <StorehouseAddNew
        :isSidebarActiveStorehouse="addNewDataSidebarinStock"
        @closeSidebar="toggleDataSidebar"
        :company="customer"
        :data="storehouseData"
      />
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>
          {{ Object.entries(this.data).length === 0 ? $t("AddNew") : $t("UPDATE") }}
        </h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <b-row>
        <b-col></b-col>
      </b-row>
      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new-mobile2"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-2">
          <b-tabs content-class="mt-3" v-model="tabIndexS1">
            <b-tab :title="$t('General')" active>
              <component
                :is="scrollbarTag"
                ref="scroll"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row v-if="ROLE != 'Company'">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('Customer')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <v-select
                        color="danger"
                        v-model="customer"
                        :options="customer_choices"
                        size="small"
                        label="name"
                        v-if="stockId || companyinfo"
                        disabled
                        v-on:input="getCustomerDepoList"
                        autocomplete
                        ref="selectElement"
                        name="customer"
                        v-validate="'required'"
                      >
                      </v-select>
                      <v-select
                        color="danger"
                        v-model="customer"
                        :options="customer_choices"
                        size="small"
                        label="name"
                        v-else
                        v-on:input="getCustomerDepoList"
                        autocomplete
                        ref="selectElement"
                        name="customer"
                        v-validate="'required'"
                      >
                      </v-select>
                      <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                        errors.first("customer")
                      }}</span>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px" align-v="center">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('Storehouse')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="7">
                      <v-select
                        color="danger"
                        v-model="storehouse"
                        :options="storehouse_choices"
                        size="small"
                        label="name"
                        v-if="stockId || companyinfo || barcodeValidate"
                        disabled
                        autocomplete
                        ref="selectElement"
                        name="storehouse"
                        v-validate="'required'"
                      >
                      </v-select>
                      <v-select
                        color="danger"
                        v-model="storehouse"
                        :options="storehouse_choices"
                        size="small"
                        label="name"
                        v-else
                        autocomplete
                        ref="selectElement"
                        name="storehouse"
                        v-validate="'required'"
                      >
                      </v-select>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('storehouse')"
                        >{{ errors.first("storehouse") }}</span
                      >
                    </b-col>
                    <b-col
                      cols="1"
                      class="ml-0"
                      style="padding-left: 0px; margin-left: 0px !important"
                    >
                      <b-button
                        v-if="customer != '' || stockId || companyinfo || barcodeValidate"
                        variant="outline-light"
                        style="padding: 0px"
                        v-on:click="addStorehouse()"
                      >
                        <Icon
                          icon="ic:outline-settings"
                          width="20"
                          height="20"
                          v-b-tooltip.hover.bottom="$t('StorehouseManagement')"
                          color="#7367F0"
                        />
                      </b-button>
                      <b-button
                        v-else
                        disabled
                        variant="outline-light"
                        style="padding: 0px"
                        v-on:click="addStorehouse()"
                      >
                        <Icon
                          icon="ic:outline-settings"
                          width="20"
                          height="20"
                          v-b-tooltip.hover.bottom="$t('StorehouseManagement')"
                          color="#7367F0"
                        />
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('Stockno')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="stockno"
                        type="text"
                        class="w-full"
                        name="stockno"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('stockno')">{{
                        errors.first("stockno")
                      }}</span>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('CustomerStockNo')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="customerStockNo"
                        type="text"
                        name="customerStockNo"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="'* ' + $t('StockName')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="stockName"
                        type="text"
                        class="w-full"
                        v-validate="'required'"
                        name="stockName"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('stockName')"
                        >{{ errors.first("stockName") }}</span
                      >
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="'* ' + $t('Brand')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="brand"
                        type="text"
                        class="w-full"
                        v-validate="'required'"
                        name="brand"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('brand')">{{
                        errors.first("brand")
                      }}</span>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('StockName2')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="stockName2"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('serialFollow')"
                        label-for="h-first-name"
                        style="font-weight: 600"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <v-select
                        color="danger"
                        v-model="serialFollow"
                        :options="serialFollow_choices"
                        size="small"
                        label="text"
                        autocomplete
                        ref="selectElement"
                      >
                      </v-select>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('Status')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <v-select
                        color="danger"
                        v-model="status"
                        :options="status_choices"
                        size="small"
                        label="text"
                        autocomplete
                        ref="selectElement"
                      >
                      </v-select>
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('CancelDate')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-datepicker
                        id="baslangic"
                        v-model="cancelDate"
                        size="md"
                        :locale="locale"
                        class="mb-2"
                        today-variant="danger"
                        placeholder="-"
                        :start-weekday="weekday"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('Description')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-textarea v-model="description" />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('Note')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-textarea v-model="note" />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
            <b-tab :title="$t('Special')">
              <component
                :is="scrollbarTag"
                ref="scroll1"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('GroupCode')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="groupCode"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '1'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode1"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '2'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode2"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '3'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode3"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '4'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode4"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '5'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode5"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '6'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode6"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '7'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode7"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '8'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode8"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '9'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode9"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('SpecCode') + '10'"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="specCode10"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
            <b-tab :title="$t('Barcodes')" v-if="stockData.length == 0" disabled>
              <component
                :is="scrollbarTag"
                ref="scroll1"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
              </component>
            </b-tab>
            <b-tab :title="$t('Barcodes')" @click="getStockBarcodes" v-else>
              <component
                :is="scrollbarTag"
                ref="scroll1"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <BarcodeAddNew :data="stockData" ref="getStockBarcodes" />
              </component>
            </b-tab>
            <b-tab
              :title="$t('SerialNumbers')"
              :disabled="stockData.length == 0"
              @click="getStockSerialNumbers"
            >
              <component
                :is="scrollbarTag"
                ref="scroll1"
                class="vs-input--label scroll-area--data-list-add-new"
                :settings="settings"
                :key="$vs.rtl"
              >
                <SerialNumberAddNew :data="stockData" ref="getStockSerialNumbers" />
              </component>
            </b-tab>
          </b-tabs>
          <vs-divider></vs-divider>
          <b-tabs content-class="mt-3" v-model="tabIndexS2">
            <b-tab :title="$t('Account')" active>
              <component
                :is="scrollbarTag"
                ref="scroll2"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('Debit')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="debit"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('Credit')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="credit"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('RemTotal')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="remTotal"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('RemType')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="remType"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
            <b-tab :title="$t('Currency')">
              <component
                :is="scrollbarTag"
                ref="scroll3"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('CurrCode')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="currCode"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('CurrDebit')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="currDebit"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('CurrCredit')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="currCredit"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('CurrRemTotal')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="currRemTotal"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('CurrRemType')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="currRemType"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
            <b-tab :title="$t('Quantity')">
              <component
                :is="scrollbarTag"
                ref="scroll4"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QEntery')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qEntery"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QExit')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qExit"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QRem')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qRem"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QRem2')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qRem2"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QRem3')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qRem3"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QReserve')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qReserve"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QReserve2')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qReserve2"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QReserve3')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qReserve3"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QDepot')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qDepot"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('UnitId')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="unitId"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QuantityMin')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="quantityMin"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QuantityMax')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="quantityMax"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('MinOrderQuantity')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="minOrderQuantity"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
          </b-tabs>
          <vs-divider></vs-divider>
          <b-tabs content-class="mt-3" v-model="tabIndexS3">
            <b-tab :title="$t('Vat')">
              <component
                :is="scrollbarTag"
                ref="scroll5"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('VatSales')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="vatSales"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('VatPurChase')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="vatPurChase"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('TaxPrivate')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="taxPrivate"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('TaxPrivateTotal')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="taxPrivateTotal"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
            <b-tab :title="$t('Other')">
              <component
                :is="scrollbarTag"
                ref="scroll6"
                class="vs-input--label scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="p-2">
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('OrdersLevel')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="ordersLevel"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('ActSupplierId')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="actSupplierId"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('PackageQuantity')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="packageQuantity"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('msg')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input size="small" v-model="msg" type="text" class="w-full" />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('minReqQuantity')"
                        label-for="h-first-name"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="minReqQuantity"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('TransCode')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="transCode"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>

                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('Origin')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="origin"
                        type="text"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 8px">
                    <b-col cols="4" align-self="center">
                      <b-form-group :label="$t('QtyTree')" label-for="h-first-name">
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="qtyTree"
                        type="number"
                        class="w-full"
                      />
                    </b-col>
                  </b-row>
                </div>
              </component>
            </b-tab>
          </b-tabs>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-2" slot="footer">
        <b-row align-h="start" class="mb-2">
          <b-col md="auto" style="width: auto">
            <b-button
              class="bg-primary"
              style="border-color: white"
              v-on:click="submitData()"
            >
              <Icon icon="material-symbols:save-outline" width="20" height="20" />{{
                $t("Save")
              }}
            </b-button>
          </b-col>
          <b-col md="auto" style="width: auto; padding: 0px">
            <b-button
              class="bg-danger"
              style="border-color: white"
              v-on:click="isSidebarActiveLocal = false"
            >
              <Icon icon="material-symbols:cancel-outline" width="20" height="20" />{{
                $t("Cancel")
              }}
            </b-button>
          </b-col>
        </b-row>
        <b-row align-h="start" v-if="Object.entries(data).length !== 0">
          <b-col md="auto" style="width: auto">
            <b-button
              class="bg-dark"
              style="border-color: white"
              v-on:click="listStockTrans(data)"
            >
              <Icon
                icon="ant-design:product-filled"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("ListStockTrans") }}
            </b-button>
          </b-col>
        </b-row>

        <!--		<vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>-->
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import SerialNumberAddNew from "./SerialNumberAddNew.vue";
import BarcodeAddNew from "./BarcodeAddNew.vue";
import StorehouseAddNew from "../storehouse/StorehouseAddNew.vue";
import { isMobile } from "mobile-device-detect";
import { Validator } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import XLSX from "xlsx";
import userJson from "../../../public/user.json";
import StockTransDetails from "./StockTransDetails.vue";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
    companyinfo: {
      default: () => {},
    },
  },
  components: {
    SerialNumberAddNew,
    StockTransDetails,
    BarcodeAddNew,
    StorehouseAddNew,
    VuePerfectScrollbar,
    vSelect,
    Icon,
    uuid,
    AgGridVue,
  },
  data() {
    return {
      isSstocktransDetailPopup: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      infoData: [],
      barcodeValidate: false,
      stockData: [],
      serialNumberData: [],
      isBarcodeAddActive: false,
      tabIndexS1: 0,
      tabIndexS2: 0,
      tabIndexS3: 0,
      storehouseData: [],
      addNewDataSidebarinStock: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      storehouse: "",
      storehouse_choices: [],
      storehouseForCustomerList: [],
      customer: "",
      customerListOption: [],
      customer_choices: [],
      isMobile: function () {
        return isMobile;
      },
      weekday: 1,
      stockId: "",
      stockno: "",
      stockName: "",
      brand: "",
      groupCode: "",
      specCode1: "",
      specCode2: "",
      specCode3: "",
      specCode4: "",
      specCode5: "",
      specCode6: "",
      specCode7: "",
      specCode8: "",
      specCode9: "",
      specCode10: "",
      status: 0,
      serialFollow: false,
      note: "",
      cancelDate: "",
      description: "",

      debit: 0,
      credit: 0,
      remTotal: 0,
      remType: 0,
      currCode: "",
      currDebit: 0,
      currCredit: 0,
      currRemTotal: 0,
      currRemType: 0,
      qEntery: 0,
      qExit: 0,
      qRem: 0,
      qRem2: 0,
      qRem3: 0,
      qReserve: 0,
      qReserve2: 0,
      qReserve3: 0,
      qDepot: 0,
      stockName2: "",
      unitId: "",
      vatSales: 0,
      vatPurChase: 0,
      quantityMin: 0, //
      quantityMax: 0,
      minOrderQuantity: 0,
      taxPrivate: 0,
      taxPrivateTotal: 0,
      ordersLevel: 0,
      actSupplierId: "",
      packageQuantity: 0,
      customerStockNo: "",
      msg: "",
      minReqQuantity: 0,
      transCode: "",
      origin: "",
      qtyTree: 0,
      depotId: "",
      mainBarcode: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      barcode: "",
      barcode_choices: [{}],
      serialFollow_choices: [
        {
          text: this.$t("Active"),
          value: true,
        },
        {
          text: this.$t("Passive"),
          value: false,
        },
      ],
      status_choices: [
        {
          text: this.$t("Active"),
          value: 1,
        },
        {
          text: this.$t("Passive"),
          value: 0,
        },
      ],
    };
  },
  watch: {
    storehouseA(val) {
      return val;
    },
    companydata(val) {
      this.getCustomerList();
      return val;
    },
    isSidebarActive(val) {
      this.tabIndexS1 = 0;
      this.tabIndexS2 = 0;
      this.tabIndexS3 = 0;
      try {
        if (val == true) {
          if (this.ROLE != "Company") this.getCustomerList();
        }
        if (!this.isMobile()) {
          this.$refs.scroll.$el.scrollTop = 0;
          this.$refs.scroll1.$el.scrollTop = 0;
          this.$refs.scroll2.$el.scrollTop = 0;
          this.$refs.scroll3.$el.scrollTop = 0;
          this.$refs.scroll4.$el.scrollTop = 0;
          this.$refs.scroll5.$el.scrollTop = 0;
          this.$refs.scroll6.$el.scrollTop = 0;
        }
        if (!val) return;
        if (this.ROLE == "Company" && Object.entries(this.data).length === 0) {
          this.customer = {
            name: "123",
            value: this.$store.state.AppActiveUser.companyid,
          };
          this.getCustomerDepoList();
        }
        if (typeof this.companyinfo == "undefined") {
          if (Object.entries(this.data).length === 0) {
            this.initValues();
            this.$validator.reset();
          } else {
            console.log(this.data);
            this.stockData = this.data;
            const { category, id, img, name, order_status, price } = JSON.parse(
              JSON.stringify(this.data)
            );
            this.customer = { name: this.data.CompanyName, value: this.data.CompanyId };
            this.stockId = this.data.StockId;
            this.stockno = this.data.Stockno;
            this.stockName = this.data.StockName;
            this.brand = this.data.Brand;
            this.groupCode = this.data.GroupCode;
            this.specCode1 = this.data.SpecCode1;
            this.specCode2 = this.data.SpecCode2;
            this.specCode3 = this.data.SpecCode3;
            this.specCode4 = this.data.SpecCode4;
            this.specCode5 = this.data.SpecCode5;
            this.specCode6 = this.data.SpecCode6;
            this.specCode7 = this.data.SpecCode7;
            this.specCode8 = this.data.SpecCode8;
            this.specCode9 = this.data.SpecCode9;
            this.specCode10 = this.data.SpecCode10;
            this.mainBarcode = this.data.mainBarcode;
            this.serialFollow = [
              {
                text:
                  this.data.SerialFollow == false || this.data.SerialFollow == null
                    ? this.$t("Passive")
                    : this.$t("Active"),
                value: this.data.SerialFollow,
              },
            ];
            this.status = [
              {
                text: this.data.Status == 0 ? this.$t("Passive") : this.$t("Active"),
                value: this.data.Status,
              },
            ];
            this.note = this.data.Note;
            this.cancelDate = this.data.CancelDate;
            this.description = this.data.Description;
            this.debit = this.data.Debit;
            this.credit = this.data.Credit;
            this.remTotal = this.data.RemTotal;
            this.remType = this.data.RemType;
            this.currCode = this.data.CurrCode;
            this.currDebit = this.data.CurrDebit;
            this.currCredit = this.data.CurrCredit;
            this.currRemTotal = this.data.CurrRemTotal;
            this.currRemType = this.data.CurrRemType;
            this.qEntery = this.data.QEntery;
            this.qExit = this.data.QExit;
            this.qRem = this.data.QRem;
            this.qRem2 = this.data.QRem2;
            this.qRem3 = this.data.QRem3;
            this.qReserve = this.data.QReserve;
            this.qReserve2 = this.data.QReserve2;
            this.qReserve3 = this.data.QReserve3;
            this.qDepot = this.data.QDepot;
            this.stockName2 = this.data.StockName2;
            this.unitId = this.data.UnitId;
            this.vatSales = this.data.VatSales;
            this.vatPurChase = this.data.VatPurChase;
            this.quantityMin = this.data.QuantityMin;
            this.quantityMax = this.data.QuantityMax;
            this.minOrderQuantity = this.data.MinOrderQuantity;
            this.taxPrivate = this.data.TaxPrivate;
            this.taxPrivateTotal = this.data.TaxPrivateTotal;
            this.ordersLevel = this.data.OrdersLevel;
            this.actSupplierId = this.data.ActSupplierId;
            this.packageQuantity = this.data.PackageQuantity;
            this.customerStockNo = this.data.CustomerStockNo;
            this.msg = this.data.Msg;
            this.minReqQuantity = this.data.MinReqQuantity;
            this.transCode = this.data.TransCode;
            this.origin = this.data.Origin;
            this.qtyTree = this.data.QtyTree;
            this.depotId = this.data.DepotId;
            this.storehouse = { name: this.data.DepotName, value: this.data.DepotId };
          }
        } else {
          this.initValues();
          if (this.ROLE != "Company")
            this.customer = {
              name: this.companyinfo.storehouseDetail.CompanyName,
              value: this.companyinfo.storehouseDetail.CompanyId,
            };
          this.storehouse = {
            name: this.companyinfo.storehouseDetail.DepotName,
            value: this.companyinfo.storehouseDetail.DepotId,
          };
        }

        return val;
      } catch (error) {
        console.log(error);
      }

      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },

  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    storehouseA: {
      get() {
        return this.$store.state.storehouse.Storehouse;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.companyName && this.companyNo > 0;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    getStockSerialNumbers() {
      this.$refs.getStockSerialNumbers.getStockSerialNumbersListForData();
    },
    listStockTrans(data) {
      this.infoData = data;
      this.isSstocktransDetailPopup = true;
    },

    getStockBarcodes() {
      this.$refs.getStockBarcodes.getStockBarcodesListForData();
    },
    addBarcodePopup(data) {
      this.isBarcodeAddActive = true;
    },
    toggleDataSidebarBarcode(val = false) {
      this.isBarcodeAddActive = val;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebarinStock = val;
    },
    addStorehouse() {
      if (this.customer != "") this.toggleDataSidebar(true);
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    updateCustomer() {
      this.storehouse = "";
      this.customer = "";
      if (this.ROLE == "Company") {
        this.customer = { name: "123", value: this.$store.state.AppActiveUser.companyid };
      }
      this.stockId = "";
      this.stockno = "";
      this.stockName = "";
      this.brand = "";
      this.groupCode = "";
      this.specCode1 = "";
      this.specCode2 = "";
      this.specCode3 = "";
      this.specCode4 = "";
      this.specCode5 = "";
      this.specCode6 = "";
      this.specCode7 = "";
      this.specCode8 = "";
      this.specCode9 = "";
      this.specCode10 = "";
      this.status = "";
      this.serialFollow = false;
      this.note = "";
      this.cancelDate = "";
      this.description = "";
      this.debit = 0;
      this.credit = 0;
      this.remTotal = 0;
      this.remType = 0;
      this.currCode = "";
      this.currDebit = 0;
      this.currCredit = 0;
      this.currRemTotal = 0;
      this.currRemType = 0;
      this.qEntery = 0;
      this.qExit = 0;
      this.qRem = 0;
      this.qRem2 = 0;
      this.qRem3 = 0;
      this.qReserve = 0;
      this.qReserve2 = 0;
      this.qReserve3 = 0;
      this.qDepot = 0;
      this.stockName2 = "";
      this.unitId = "";
      this.vatSales = 0;
      this.vatPurChase = 0;
      this.quantityMin = 0;
      this.quantityMax = 0;
      this.minOrderQuantity = 0;
      this.taxPrivate = 0;
      this.taxPrivateTotal = 0;
      this.ordersLevel = 0;
      this.actSupplierId = "";
      this.packageQuantity = 0;
      this.customerStockNo = "";
      this.msg = "";
      this.minReqQuantity = 0;
      this.transCode = "";
      this.origin = "";
      this.qtyTree = 0;
      this.depotId = "";
      this.mainBarcode = "";
    },
    initValues() {
      if (this.data.id) return;
      this.storehouse = "";
      this.customer = "";
      if (this.ROLE == "Company") {
        this.customer = { name: "123", value: this.$store.state.AppActiveUser.companyid };
      }
      this.stockId = "";
      this.stockno = "";
      this.stockName = "";
      this.brand = "";
      this.groupCode = "";
      this.specCode1 = "";
      this.specCode2 = "";
      this.specCode3 = "";
      this.specCode4 = "";
      this.specCode5 = "";
      this.specCode6 = "";
      this.specCode7 = "";
      this.specCode8 = "";
      this.specCode9 = "";
      this.specCode10 = "";
      this.status = "";
      this.serialFollow = false;
      this.note = "";
      this.cancelDate = "";
      this.description = "";
      this.debit = "";
      this.credit = "";
      this.remTotal = "";
      this.remType = "";
      this.currCode = "";
      this.currDebit = "";
      this.currCredit = "";
      this.currRemTotal = "";
      this.currRemType = "";
      this.qEntery = "";
      this.qExit = "";
      this.qRem = "";
      this.qRem2 = "";
      this.qRem3 = "";
      this.qReserve = "";
      this.qReserve2 = "";
      this.qReserve3 = "";
      this.qDepot = "";
      this.stockName2 = "";
      this.unitId = "";
      this.vatSales = "";
      this.vatPurChase = "";
      this.quantityMin = "";
      this.quantityMax = "";
      this.minOrderQuantity = "";
      this.taxPrivate = "";
      this.taxPrivateTotal = "";
      this.ordersLevel = "";
      this.actSupplierId = "";
      this.packageQuantity = "";
      this.customerStockNo = "";
      this.msg = "";
      this.minReqQuantity = "";
      this.transCode = "";
      this.origin = "";
      this.qtyTree = "";
      this.depotId = "";
      this.stockData = [];
      this.mainBarcode = "";
    },
    getCustomerDepoList() {
      const vs = this.$vs;
      this.storehouse_choices = [];
      if (userJson.type == "fullfilment")
        this.$store.dispatch("storehouse/listStorehouseAllValues2").then((response) => {
          // let costumerList = JSON.parse(response.json);

          if (response.success == true) {
            this.storehouseForCustomerList = this.storehouseA;
            this.storehouseForCustomerList.forEach((val, index) => {
              this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
            });
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
      else
       { 
				let depotMethods = "listStorehouseForCompany"

				if (userJson.type == "dropshipping") depotMethods = "listStorehouseAllValues2Ds"
				this.$store
          .dispatch("storehouse/"+depotMethods, this.customer.value)
          .then((response) => {
            // let costumerList = JSON.parse(response.json);

            if (response.success == true) {
              this.storehouseForCustomerList = JSON.parse(response.json);
              this.storehouseForCustomerList.forEach((val, index) => {
                this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
              });
            } else console.log(response.statusText);
            /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
          });}
    },
    submitData() {
      var createdId = uuid.v4();
      var createdGroupId = uuid.v4();

      const vs = this.$vs;
      const today = new Date();
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = [
            {
              stockId: this.stockId != "" ? this.stockId : createdId,
              stockno: this.stockno,
              stockName: this.stockName,
              brand: this.brand,
              groupCode: this.groupCode,
              specCode1: this.specCode1,
              specCode2: this.specCode2,
              specCode3: this.specCode3,
              specCode4: this.specCode4,
              specCode5: this.specCode5,
              specCode6: this.specCode6,
              specCode7: this.specCode7,
              specCode8: this.specCode8,
              specCode9: this.specCode9,
              specCode10: this.specCode10,
              status: typeof this.status.value == "undefined" ? 1 : this.status.value,
              serialFollow:
                typeof this.serialFollow.value == "undefined"
                  ? false
                  : this.serialFollow.value,
              note: this.note,
              cancelDate: this.cancelDate == "" ? null : this.cancelDate,
              description: this.description,
              debit: parseFloat(this.debit == "" ? 0 : this.debit),
              credit: parseFloat(this.credit == "" ? 0 : this.credit),
              remTotal: parseFloat(this.remTotal == "" ? 0 : this.remTotal),
              remType: parseFloat(this.remType == "" ? 0 : this.remType),
              currCode: this.currCode,
              currDebit: parseFloat(this.currDebit == "" ? 0 : this.currDebit),
              currCredit: parseFloat(this.currCredit == "" ? 0 : this.currCredit),
              currRemTotal: parseFloat(this.currRemTotal == "" ? 0 : this.currRemTotal),
              currRemType: parseFloat(this.currRemType == "" ? 0 : this.currRemType),
              qEntery: parseFloat(this.qEntery == "" ? 0 : this.qEntery),
              qExit: parseFloat(this.qExit == "" ? 0 : this.qExit),
              qRem: parseFloat(this.qRem == "" ? 0 : this.qRem),
              qRem2: parseFloat(this.qRem2 == "" ? 0 : this.qRem2),
              qRem3: parseFloat(this.qRem3 == "" ? 0 : this.qRem3),
              qReserve: parseFloat(this.qReserve == "" ? 0 : this.qReserve),
              qReserve2: parseFloat(this.qReserve2 == "" ? 0 : this.qReserve2),
              qReserve3: parseFloat(this.qReserve3 == "" ? 0 : this.qReserve3),
              qDepot: parseFloat(this.qDepot == "" ? 0 : this.qDepot),
              stockName2: this.stockName2,
              unitId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
              vatSales: parseFloat(this.vatSales == "" ? 0 : this.vatSales),
              vatPurChase: parseFloat(this.vatPurChase == "" ? 0 : this.vatPurChase),
              quantityMin: parseFloat(this.quantityMin == "" ? 0 : this.quantityMin),
              quantityMax: parseFloat(this.quantityMax == "" ? 0 : this.quantityMax),
              minOrderQuantity: parseFloat(
                this.minOrderQuantity == "" ? 0 : this.minOrderQuantity
              ),
              taxPrivate: parseFloat(this.taxPrivate == "" ? 0 : this.taxPrivate),
              taxPrivateTotal: parseFloat(
                this.taxPrivateTotal == "" ? 0 : this.taxPrivateTotal
              ),
              ordersLevel: parseFloat(this.ordersLevel == "" ? 0 : this.ordersLevel),
              actSupplierId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
              packageQuantity: parseFloat(
                this.packageQuantity == "" ? 0 : this.packageQuantity
              ),
              customerStockNo: this.customerStockNo,
              msg: this.msg,
              minReqQuantity: parseFloat(
                this.minReqQuantity == "" ? 0 : this.minReqQuantity
              ),
              transCode: this.transCode,
              origin: this.origin,
              qtyTree: parseFloat(this.qtyTree == "" ? 0 : this.qtyTree),
              depotId: this.storehouse.value,
              depotName: this.storehouse.name,
              brand: this.brand,
              barcode: this.mainBarcode,
              CompanyId: this.customer.value,
              CompanyInfoId: "",
              CompanyInfoName: "",
              CompanyName: this.customer.name,
            },
          ];
          if (this.stockId != "") {
            this.$store
              .dispatch("stock/updateStock", obj[0])
              .then((response) => {
                if (response.status == 200) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.$root.$emit("getStockList");
                  this.$root.$emit("getStockListForPalletItems");

                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              })
              .catch((error) => {
                return new Promise((resolve, reject) => {
                  resolve(false);
                });
              });
          } else {
            delete obj.id;
            console.log(obj);
            this.$store
              .dispatch("stock/addStockList", obj)
              .then((response) => {
                if (response.status == 200) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.stockData = JSON.parse(response.data.json);
                  this.$root.$emit("getStockList");
                  this.$root.$emit("getStockListForPalletItems");
                  if (!this.companyinfo) {
                  } //this.initValues()
                  else this.barcodeValidate = true;
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              })
              .catch((error) => {
                return new Promise((resolve, reject) => {
                  resolve(false);
                });
              });
          }
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    updateCurrImg(input) {
      const vs = this.$vs;
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();

        if (input.target.files[0].size > 102400)
          vs.notify({
            text: this.$t("ImageSize"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
          });
        else
          reader.onload = (e) => {
            this.companyLogo = e.target.result;
          };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
  created() {
    this.locale = this.$i18n.locale == "en" ? "en-US" : this.$i18n.locale;
    const dict = {
      custom: {
        mainBarcode: {
          required: this.$t("mainBarcodeRequired"),
          alpha: this.$t("mainBarcodeRequired"),
        },
        storehouse: {
          required: this.$t("storehouseRequired"),
          alpha: this.$t("storehouseRequired"),
        },
        customer: {
          required: this.$t("customerRequired"),
          alpha: this.$t("customerRequired"),
        },
        stockno: {
          required: this.$t("stocknoRequired"),
          alpha: this.$t("stocknoRequired"),
        },
        customerStockNo: {
          required: this.$t("customerStockNoRequired"),
          alpha: this.$t("customerStockNoRequired"),
        },
        stockName: {
          required: this.$t("stocknameRequired"),
          alpha: this.$t("stocknameRequired"),
        },
        brand: {
          required: this.$t("brandRequired"),
          alpha: this.$t("brandRequired"),
        },
      },
    };
    Validator.localize("en", dict);
  },
  mounted() {
    this.$root.$on("getStorehouseList", () => {
      this.getCustomerDepoList();
    });
  },
  beforeDestroy() {
    this.$root.$off("getStorehouseList");
  },
};
</script>
<style lang="scss">
.vs-notifications {
  z-index: 21111111 !important;
}
.con-vs-dialog {
  z-index: 520011155;
}
</style>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 520110;
  }

  ::v-deep .vs-sidebar {
    z-index: 520110;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.scroll-area--data-list-add-new-mobile2 {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 50px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.scroll-area--data-list-add-new-mobile {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 100px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.vs-input--label {
  color: black;
  font-size: small;
}
</style>
